import React, { FC } from 'react';
import Box from '@/components/UI/box/Box';
import HouseInfo from '@/components/houses/_reusable/houseInfo/HouseInfo';
import useHouse from '@/components/houses/_hooks/useHouse';
import TopSlider from './TopSlider/TopSlider';
import NavbarDesktop from '@/components/houses/housesDesktop/navbar/NavbarDesktop';
import HouseInfoFooter from '../_reusable/houseInfoFooter/HouseInfoFooter';
import PriceBox from '@/components/houses/housesDesktop/priceBox/PriceBox';
import { ProductItemTypes } from '../_types/productItem.types';
import styles from './HouseDesktop.module.scss';
type HousesDesktopProps = {
  data: ProductItemTypes;
  host: string;
};
const HousesDesktop: FC<HousesDesktopProps> = ({
  data,
  host
}) => {
  const {
    loading,
    calendarPricing,
    onSendReserveRequestClick,
    isNonBookable
  } = useHouse(data);
  return <Box component={'main'} data-sentry-element="Box" data-sentry-component="HousesDesktop" data-sentry-source-file="HousesDesktop.tsx">
      <Box component={'article'} data-sentry-element="Box" data-sentry-source-file="HousesDesktop.tsx">
        <Box component={'header'} data-sentry-element="Box" data-sentry-source-file="HousesDesktop.tsx">
          <TopSlider productState={data} data-sentry-element="TopSlider" data-sentry-source-file="HousesDesktop.tsx" />
        </Box>
        <NavbarDesktop id={data?.id} data-sentry-element="NavbarDesktop" data-sentry-source-file="HousesDesktop.tsx" />
        <Box className={styles['layout']} data-sentry-element="Box" data-sentry-source-file="HousesDesktop.tsx">
          <Box className={styles['content-container']} data-sentry-element="Box" data-sentry-source-file="HousesDesktop.tsx">
            <HouseInfo productState={data} calendarPricing={calendarPricing} host={host} data-sentry-element="HouseInfo" data-sentry-source-file="HousesDesktop.tsx" />
            <HouseInfoFooter productState={data} host={host} data-sentry-element="HouseInfoFooter" data-sentry-source-file="HousesDesktop.tsx" />
          </Box>
          <Box className={styles['price-box']} data-sentry-element="Box" data-sentry-source-file="HousesDesktop.tsx">
            <PriceBox isNonBookable={isNonBookable} loading={loading} data={data} calendarPricing={calendarPricing} onSendReserveRequestClick={onSendReserveRequestClick} data-sentry-element="PriceBox" data-sentry-source-file="HousesDesktop.tsx" />
          </Box>
        </Box>
      </Box>
    </Box>;
};
export default HousesDesktop;